export const helpShiftHandlers = () => {
    $('.to-up').click(e => {
        e.preventDefault();

        $('body,html').animate({'scrollTop': 0}, 1000);
    });

    $(".help-shift-nav__form input").keyup(function (event) {
        if (event.keyCode === 13) {
            $(this).next('button').click();
        }
    });
};
